import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.string.starts-with.js";
import clearCognitoCookies from 'utils/clearCognitoCookies';
var COGNITO_PREFIX = 'CognitoIdentityServiceProvider.';

// Removes residual authentication material from browser storage on logout.
//
// Amplify's own signOut clears its token cookies (host-only), so this deliberately does NOT
// touch them (Amplify still needs the access token to run GlobalSignOut).
// It sweeps the legacy domain-wide SSR cookies and any Cognito sessionStorage entries
// so that no authentication information survives in the browser after signing out.
var purgeAuthStorage = function purgeAuthStorage() {
  try {
    clearCognitoCookies();
    if (typeof window === 'undefined' || !window.sessionStorage) return;
    Object.keys(window.sessionStorage).filter(function (key) {
      return key.startsWith(COGNITO_PREFIX);
    }).forEach(function (key) {
      return window.sessionStorage.removeItem(key);
    });
  } catch (e) {
    // swallow — never let storage cleanup block sign-out
  }
};
export default purgeAuthStorage;